'use strict'

var page = page || {}
var $ = jQuery

/* INIT
 ----------------------------------------------------------------------------------------------------------------------*/
page.init = function () {
  page.headerCollapse()
  page.menuPremium()
  page.tooltip()
  page.figureSize()
}

/* DOM READY
 ----------------------------------------------------------------------------------------------------------------------*/
$(page.init)

/* FUNCTIONS
 ----------------------------------------------------------------------------------------------------------------------*/
// Show and hide header collapsed submenus
page.headerCollapse = function () {

  $(document).click(function (event) {
    $(event.target).closest('.collapse').length || $('.collapse.show').length &&
    $('.collapse.show').collapse('hide')
  })

}

// Move button compte
page.menuPremium = function () {

  var menuPremium = $('#membrePremium');
  var buttonCompte = $('.block-content--boutoncompte');

  menuPremium.appendTo(buttonCompte);

}

// Add bootstrap tooltips
page.tooltip = function () {

  $(function () {
    $('[data-toggle="tooltip"]').tooltip();
  })

}

// Set width on images wrapper
page.figureSize = function () {

  function setSize() {

    var paragraph = $('.paragraph');
    var figure = paragraph.find('figure');
    var article = paragraph.find('article');

    figure.each(function () {
      var imgWidth = $(this).find('img').width();
      $(this).css("width", imgWidth + "px");
    });
    article.each(function () {
      var imgWidth = $(this).find('img').width();
      $(this).css("width", imgWidth + "px");
    });
  }

  setSize();

  window.onload = function () {
    setSize();
  }

  $(window).resize(function () {
    setSize();
  });

}
